<template>
	<li
		:id="id"
		:aria-selected="selected.toString()"
		:class="{ selected: selected }"
		role="option"
		@click="select(id)"
	>
		<slot />
	</li>
</template>

<script>
import { SelectOption } from "../mixins";

export default {
	name: "SelectOption",

	mixins: [SelectOption]
};
</script>
